import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import styled from 'styled-components'
import { Form, notification } from 'antd'
import { yupResolver } from '@hookform/resolvers/yup'
import { FirebaseService, SignInSchema } from 'utility'
import { InputTextField, LoaderBar, PrimaryButton } from 'components'
import { useNavigate } from 'react-router-dom'
import { useAuth } from 'context'

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f8f9fa;
  height: 100vh;
  position: relative;
`

const OverlayLoader = styled.div`
  position: absolute;
  z-index: 1000;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: rgba(255, 255, 255, 0.7);
`

const LoginForm = styled.div`
  width: 600px;
  background: ${({ theme }) => theme.colors.white};
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  padding: 24px;

  .ant-form-item {
    margin-bottom: 0 !important;
  }
`

const Title = styled.h2`
  margin-bottom: 20px;
  font-size: 24px;
  font-weight: bold;
  color: #2c2c2c;
`

export const SignInScreen = () => {
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(SignInSchema),
  })
  const { login } = useAuth()
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)

  const onSubmit = async data => {
    try {
      setLoading(true)
      const result = await FirebaseService.loginWithAdmin(
        data.email,
        data.password,
      )
      login(result)
      notification.success({
        message: 'Success!',
        description: 'Sign In Successfully',
      })
      navigate('/app/dashboard')
    } catch (error) {
      notification.error({
        description: error.toString(),
        message: 'Invalid Credentials',
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <Container>
      {loading && (
        <OverlayLoader>
          <LoaderBar height="100vh" content="Signing in..." />
        </OverlayLoader>
      )}
      <LoginForm>
        <Form className="p-4 p-md-5 p-lg-3">
          <Title className="mt-0 d-flex justify-content-center">Login</Title>
          <Form.Item>
            <InputTextField
              name="email"
              label="Email Address"
              control={control}
              errors={errors}
              required
              placeholder="Enter Email Address"
            />
          </Form.Item>
          <Form.Item>
            <InputTextField
              name="password"
              control={control}
              errors={errors}
              label="Password"
              required
              placeholder="Enter your password"
              type="password"
            />
          </Form.Item>

          <PrimaryButton
            htmlType="submit"
            fullWidth
            loading={loading}
            onClick={handleSubmit(onSubmit)}
          >
            {loading ? 'Signing in...' : 'Login'}
          </PrimaryButton>
        </Form>
      </LoginForm>
    </Container>
  )
}
